import { IsFunction } from "@pdfking/tfunc"

export const IsWorker = (): boolean =>
  typeof self === "object" &&
  IsFunction((self as any).importScripts) &&
  typeof window === "undefined"
